import * as React from 'react'
import Background from '../background/Background'
import { IWish } from 'types'
import { wishCategories } from '../wishes/wishes'
import { RouteComponentProps } from 'react-router'
import Title from '../titlte/Title'
import WishSavedButton from '../buttons/WishButton'
import { db, addWish } from '../../db'
import { RematchRootState } from '@rematch/core'
import { models } from '../../store'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

interface WishSavedProps {}

const getWishSavedConfigForType = (type: IWish['type']): IWish | undefined => {
  return wishCategories.find(wish => wish.type === type)
}

interface WishSavedState {}

class WishSaved extends React.Component<WishSavedProps & RouteComponentProps<{ type: string }>, WishSavedState> {
  constructor(props: WishSavedProps & RouteComponentProps<{ type: string }>) {
    super(props)
    this.state = {}
  }

  render() {
    const {
      match: { params },
    } = this.props

    const wish = getWishSavedConfigForType(params.type as IWish['type'])

    if (!wish) {
      return null
    }

    return (
      <div style={{ height: '100vh', overflow: 'hidden', color: 'white' }}>
        <Background style={{ padding: '16px 16px 0 16px' }}>
          <div
            style={{
              position: 'relative',
              width: '100%',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
            }}
          >
            <Title size="32px">Dein Wunsch für eine {wish.name} wurde gespeichert</Title>
            <Title size="20px" style={{ marginTop: '20px' }}>
              Wir hoffen dass hier zukünftig ein Angebot für {wish.name} bereitgestellt wird
            </Title>
            <Title size="16px" style={{ marginTop: 'auto' }}>
              Sieh dir doch auch die Wünsche anderer Personen an
            </Title>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                color: 'white',
                marginBottom: '20px',
                height: '76px',
                minHeight: '76px',
              }}
            >
              <Link to={`/category/${wish.type}/map`}>
                <WishSavedButton
                  style={{
                    height: '56px',
                    minHeight: '56px',
                    backgroundColor: '#FFE066',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    marginTop: '10px',
                  }}
                >
                  Wunschkarte öffnen
                </WishSavedButton>
              </Link>
            </div>
          </div>
        </Background>
      </div>
    )
  }
}

export default WishSaved



// WEBPACK FOOTER //
// ./src/components/routes/WishSaved.tsx